<template>
    <div class="container">
        <article>
            <section :class="animation">
                <h2>Qbility Web-Tool | Einführung</h2>

                <div class="informations">
                    <h3>
                        Das Qbility Web-Tool wurde im Rahmen des
                        Forschungsprojektes „Qbility | Quality 4.0 Capability
                        Determination Model“ erstellt.<br />
                        <br />

                        Das Qbility Web-Tool basiert auf einem innerhalb des
                        Forschungsprojektes entwickelten Qualitä 4.0
                        Reifegradmodell und soll insbesondere KMU dazu
                        befähigen, ihren eigenen Qualität 4.0 Reifegrad durch
                        die Beantwortung von Fragen abzuschätzen. <br />
                        <br />

                        Die Bestimmung des Qualität 4.0 Reifegrades erfolgt
                        entlang des Produktlebenszyklus in 7 Phasen von der
                        Planung und Konzeption bis hin zum Recycling. In jeder
                        Phase werden zuerst phasenspezifische Fragen und
                        anschließend allgemeingültige Rahmenbedingungen
                        abgefragt.<br />
                        <br />

                        Bitte beantworten Sie die auf den folgenden Seiten
                        formulierten Fragen. Um die Mess- und Vergleichbarkeit
                        der gegebenen Antworten zu ermöglichen, werden die
                        Antworten auf einer Skala von 1 (Antwort: „nein“) bis 5
                        (Antwort: „vollumfänglich umgesetzt/automatisiert“)
                        aufgenommen.<br />
                        <br />

                        Nach Beantwortung der Fragen erhalten Sie eine
                        Auswertung Ihres individuellen Qualität 4.0 Reifegrades
                        sowie automatisch abgeleitete Handlungsempfehlungen, die
                        Ihnen Anhaltspunkte zur Verbesserung des ermittelten
                        Reifegrades liefern. <br />
                    </h3>
                </div>
            </section>
        </article>
        <div class="col-1 align-self-center">
            <!--<arrow
                direction="right"
                :route="'/firstInfos'"
                :routeName="description"
            ></arrow>-->
            <arrow
                direction="right"
                :route="'/question'"
                :routeName="description"
            >
            </arrow>
        </div>
    </div>
</template>

<script>
import Arrow from "../js/components/Arrow.vue";

export default {
    components: {
        Arrow
    },

    data: function() {
        return {
            description: "Weiter",
            count: 0
        };
    },
    methods: {
        nextStep() {
            this.count += 1;
            window.scrollTo(0, 0);
        }
    }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Noto+Sans&display=swap");
@mixin flexbox() {
    display: flex;
    justify-content: center;
    align-items: center;
}
.container {
    @include flexbox();
    width: 100%;
    font-family: "Noto Sans", sans-serif;
}
article {
    display: flex;
    margin: 10px;
    width: calc(100% - 20px);
    max-width: 15000px;
    min-height: 280px;
    perspective: 1000px;

    section {
        @include flexbox();
        align-items: center;
        flex-direction: column;
        width: 1500px;
        background-color: #fff;
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2),
            0 10px 10px rgba(0, 0, 0, 0.2);
        h2 {
            text-align: left;
            font-size: 2rem;
            color: #179c7d;
            margin: 0px;
            padding-top: 20px;
            padding-bottom: 20px;
        }

        .informations {
            border-style: groove;
            margin: 20px;

            h3 {
                display: flex;
                margin: 10 px;
                font-size: 1.5rem;
                color: rgb(1, 71, 36);
                padding-bottom: 30px;
                padding-top: 30px;
                padding-left: 30px;
                padding-right: 30px;
                box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2),
                    0 10px 10px rgba(0, 0, 0, 0.2);
            }
        }
    }
}
</style>
